
import { mapState, mapActions } from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'

import meiqia from '../../utils/meiqia'
import imagePhone from 'assets/icons/icon-customer-phone@3x.png'

export default {
name: 'CustomIntro',
components: {
XHeader,
XButton,
Confirm,
Previewer,
},
data() {
return {
show: false,
imagePhone,
imgList: [],
}
},
computed: {
...mapState({
customOrder: ({ order }) => order.customOrder,
}),
hasConfirm() {
const { customOrder } = this
switch (customOrder.status) {
case 1:
case 4:
case 5:
case 6:
case 9:
case 91:
case 11:
return true
default:
return false
}
},
},
methods: {
...mapActions(['fetchCustomOrder', 'showToast']),
confirmRoute() {
const self = this
if (!this.hasConfirm) {
const { userId } = this.$jwt

const req = {
orderId: this.customOrder.id,
userId,
}

this.$http.post('/api/custom/confirmRoute', req).then(res => res.json())
.then(() => {
self.$router.push({
name: 'order-list',
query: { listType: 2 },
})
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
}
},
chat() {
meiqia.showPanel()
},
generateImgList() {
const images = document.querySelectorAll('.custom-intro-wrapper img')
return Array.from(images).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || 600,
h: img.getAttribute('data-height') || 400,
}))
},
popUpImg(event) {
if (event.target.tagName === 'IMG') {
const idx = this.imgList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
},
},
created() {
meiqia.init(this.$route.name)
const { customOrderId } = this.$route.params
const request = {
customOrderId,
}
this.fetchCustomOrder(request).then(() => {
this.imgList = this.generateImgList()
})
},
}



// WEBPACK FOOTER //
// ./client/components/Custom/CustomIntro.vue